import { apiRequest } from "../util/apiUtils";

export const taxList = async (params) => {
  try {
    const res = await apiRequest("get", `tax/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const taxAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `tax/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const taxDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `tax/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const taxStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `tax/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
